// Kimlik doğrulama yardımcı fonksiyonları

/**
 * Kimlik doğrulama başlığını döndürür
 * @returns Kimlik doğrulama başlığı içeren nesne
 */
export const getAuthHeader = () => {
  // Önce localStorage'dan kontrol et, yoksa sessionStorage'dan kontrol et
  const token = localStorage.getItem('accessToken') || 
                localStorage.getItem('token') || 
                sessionStorage.getItem('accessToken') || 
                sessionStorage.getItem('token');
  
  return {
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json'
  };
};
